import * as geojson from 'geojson';
import React from 'react';

import MapContent, {Coordinates} from 'app/components/DeclarativeMap/MapContent';

const ID = 'ImageryTimeline-frame';

const TimelineRaster: React.FunctionComponent<{
  map: mapboxgl.Map;
  isMapLoaded: boolean;
  frame: {imageUrl: string; bounds: geojson.BBox} | null;
}> = ({map, isMapLoaded, frame}) => {
  // Stays mounted without a frame so its MapContent keeps its place in the layer stack.
  if (!frame) {
    return <MapContent map={map} isMapLoaded={isMapLoaded} sources={[]} layers={[]} />;
  }

  const {imageUrl, bounds} = frame;
  const coordinates: Coordinates = [
    [bounds[0], bounds[3]],
    [bounds[2], bounds[3]],
    [bounds[2], bounds[1]],
    [bounds[0], bounds[1]],
  ];

  return (
    <MapContent
      map={map}
      isMapLoaded={isMapLoaded}
      sources={[{id: ID, source: {type: 'image', url: imageUrl, coordinates}}]}
      layers={[
        {
          id: ID,
          type: 'raster',
          source: ID,
          paint: {'raster-fade-duration': 0, 'raster-resampling': 'linear'},
        },
      ]}
    />
  );
};

export default TimelineRaster;
